import { Component, Input } from '@angular/core';
import { ErrorMessage } from 'src/app/core/models/error-message.model';
import { Util } from 'src/app/shared/utils/util';

@Component({
  selector: 'app-alert-custom',
  templateUrl: './alert-custom.component.html',
  styleUrls: ['./alert-custom.component.scss']
})
export class AlertCustomComponent {

  @Input() error = new ErrorMessage();
  @Input() closeable: boolean = true;
  @Input() title = 'Alerta!'

  closeAlert() {
    Util.clearErrorMessage(this.error);
  }

  typeError() {
    const errorTypeMap = {
      'danger': 'alert-danger',
      'success': 'alert-success',
      'info': 'alert-info',
      'warning': 'alert-warning'
    }

    return errorTypeMap[this.error.errorType] || 'alert-dark';
  }

}
